import { generateRandomDigit } from '../utility';

const RANDOM_DIGIT_MIN = 0;
const RANDOM_DIGIT_MAX = 10;

export const SITE_NAME_PREFIX = 'team-';

export function useSiteNameGeneration(): string {
  return `${SITE_NAME_PREFIX}${Date.now()}${generateRandomDigit(
    RANDOM_DIGIT_MIN,
    RANDOM_DIGIT_MAX
  )}`;
}
